export default "__VITE_ASSET__CzPSaz7w__"